import React,{Component} from 'react';
import { Collapse } from 'reactstrap';
import {  CardBody, CardTitle, CardText} from 'reactstrap';
import {Col,Row} from 'reactstrap';
import Aux from '../../global/AuxComp';
import {StatusButton} from './verifier_status_button';
import { CONSTANTS } from '../../../constants';
import moment from 'moment';
import { connect } from 'react-redux';

class ProfessionalDetailCollapse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false
      };
    this.section = Math.ceil(Math.random() * 10000)
    this.popoverName = "POP-" + this.section
  }

  toggle = () => {
    this.props.toggleSection(this.section)
    this.props.getfileId(this.props.professionalDetail.file);
  }

  render() {
    let professionalDetail = this.props.professionalDetail;
    let allCommentThread= this.props.getAllCommentThread!=null?(this.props.getAllCommentThread.filter(commentThread=>
       commentThread.profile_type=="PROFESSIONAL" && commentThread.profile_id==professionalDetail.professional_id && commentThread.student_id==professionalDetail.student_id &&commentThread.verifier_id==this.props.role.assigned_role_id)):null;

    return (
      <Aux>
      <CardBody onClick={this.toggle}   className={"verifier__card-body  "+(this.section==this.props.collapse?"active":"")}>
      <CardTitle>
      <Row>
      <Col xs={10}>
      <span className="r-heading-6 mr-3">
      {professionalDetail.designation_name ||  "Designation Name"}</span>
      <span>{"("+moment(professionalDetail.start_date).format("MMM")+" "+moment(professionalDetail.start_date).year()+" - "}{professionalDetail.end_date?moment(professionalDetail.end_date).format("MMM")+" "+moment(professionalDetail.end_date).year(): "Currently Working"}{")"} </span>
      </Col>
      {this.props.files && this.props.files[professionalDetail.file] && this.props.files[professionalDetail.file].length>0? <Col xs={2} align="end">
          <span title="Proof Attached"><img src="/images/paper-clip@2x.png" alt="Proof" className="w-25" /></span>
      </Col> : null}
      </Row>
      </CardTitle>
      <CardText>
      <Row>
      <Col xs="auto">
      <span>{CONSTANTS.EXPERIENCE_TYPES[professionalDetail.experience_type]} | {professionalDetail.sector_name}
      </span>
      </Col>
      </Row>
      <Row>
      <Col xs="auto" className="r-subheading-3">
      <p>{professionalDetail.company_name!=null? professionalDetail.company_name : ""} {" "} {"("+(professionalDetail.industry_name!=null?professionalDetail.industry_name:"")+")"} {" "+" | "+professionalDetail.location}
      </p>
      </Col>
      </Row>
      </CardText>
      </CardBody>
      <Collapse   className="r-bg--blue-1" isOpen={this.props.collapse==this.section}>

      <StatusButton allCommentThread={allCommentThread} student_id={professionalDetail.student_id} id={professionalDetail.professional_id} profileType="PROFESSIONAL" profile_type="professional_detail" getStudentDetails={this.props.getStudentDetails}  popoverName={this.popoverName} data={professionalDetail}
      />
      </Collapse>
      </Aux>
    );
  }
}

 const mapStateToProps = state => ({
   ...state
 })
export default connect(mapStateToProps, null)(ProfessionalDetailCollapse)
// export default ProfessionalDetailCollapse;
